import { withInstall } from '@ll-plus/utils'

import AudioPlayer from './src/audio-player.vue'

export const LlAudioPlayer = withInstall(AudioPlayer)

export * from './src/audio-player'

declare module 'vue' {
  export interface GlobalComponents {
    LlAudioPlayer: typeof AudioPlayer
  }
}
